import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-118" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-119" data-mp="1dxjkfkoq7bg7">
        <div className="text-center" data-id="element-120" data-mp="1dunlpu520iqp">
          <span className="inline-flex items-center gap-2 rounded-md bg-skyDeep px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-white" data-id="element-121" data-mp="2bkiedno1a5ae">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-122" data-mp="26jb9pxh6tm7y" /> Material completo para el aula
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-123" data-mp="1wn88quy2ntml">
            Los {totalVolumes} tomos del Megapack
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-124" data-mp="q4t7p9900o4v">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-line bg-panel shadow-card" data-id="element-125" data-mp="1iwjw018fd8x6" data-mpi={index}>
                <div className="flex items-center gap-4 bg-skyDeep px-6 py-5" data-id="element-126" data-mp="102wigtlzxxlw">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-gold text-navyDeep" data-id="element-127" data-mp="14xk6ysh02s0h">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-128" data-mp="v5nx6k5jxdgf" />
                  </span>
                  <div data-id="element-129" data-mp="v3be23o24x1s">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-mutedDark" data-id="element-130" data-mp="h5d4dbkolosm">
                      Tomo {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-white" data-id="element-131" data-mp="l9b2biy9stk3">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-132" data-mp="2j2dt8ky771l1">
                  <p className="font-semibold text-accent" data-id="element-133" data-mp="2e42m4hzaf56i">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-muted" data-id="element-134" data-mp="2e1zl72wljrn0">
                    ¿Qué resuelve en el aula?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-135" data-mp="36shnw2terqzw">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 gap-2" data-id="element-136" data-mp="31ug57izw9toy">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-ink" data-id="element-137" data-mp="2wt0jdopw7j5i">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-138" data-mp="2ssoxy9pphesz" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-gold bg-goldSoft p-4 text-sm leading-relaxed text-ink" data-id="element-139" data-mp="1hcs0fx3sxmk5">
                    <b className="font-extrabold text-gold" data-id="element-140" data-mp="3szlt3lb7ya69">Resultado: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-skyDeep px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-141" data-mp="anyznlz9b36w">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-mutedDark" data-id="element-142" data-mp="fm8ws24jkdv5">Colección principal</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-143" data-mp="knpuxpvn5m81">
            {totalVolumes} tomos premium <span className="mx-2 text-gold" data-id="element-144" data-mp="tmb978u2yf30">·</span> Contenido actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}